import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    viewBox: "0 0 24 24",
    color: "#193446",
    xmlns: "http://www.w3.org/2000/svg",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path d="m21.67 20.66-5.49-5.54a8 8 0 0 0 1.84-5.11C18.02 5.6 14.43 2 10.01 2S2 5.6 2 10.01s3.59 8.02 8.01 8.02c1.95 0 3.73-.7 5.12-1.85l5.47 5.53c.15.15.34.23.53.23s.38-.08.53-.22c.29-.29.3-.77.01-1.06m-11.66-4.13c-3.59 0-6.51-2.92-6.51-6.52S6.42 3.5 10.01 3.5s6.51 2.93 6.51 6.51-2.92 6.52-6.51 6.52" fill="currentColor"/>' }
  })
);